import React from 'react';
import BulkVehicleUpload from '../components/vehicles/BulkVehicleUpload';

const BulkVehicleImport: React.FC = () => {
  return <BulkVehicleUpload />;
};

export default BulkVehicleImport;
